import React from "react"
import { getCart, productsCount, useCartStateStore } from "../../../stores/CartStateStore"
import ItemPrice from "../../../ui-components/ItemPrice"

import style from "./CheckoutButton.module.scss"

function CheckoutButton(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { disabled = false, onClick } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [cartState, dispatchCartState] = useCartStateStore()

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const text = disabled ? I18n.t("wait") + "..." : I18n.t("continue")

  const {
    products,
    promotion,
    discount_amount,
    total,
    subtotal = 0,
    original_subtotal,
  } = getCart(cartState)

  const count = productsCount(products)

  // -------------------------------------

  return (
    <div className={style.container}>
      <div className={style.infoContainer}>
        <div className={style.infoInnerContainer}>
          <div className={style.totalContainer}>
            <p className={style.total}>{I18n.t("total")}</p>
            <ItemPrice className={style.totalPrice} priceCents={total} />
          </div>
          {!discount_amount && (
            <div className={style.description}>
              {I18n.t("total_products_added", { count: count })}
            </div>
          )}
          {!!discount_amount && (
            <div className={style.description}>
              {I18n.t("total_discount_desc", {
                discount_amount: ((original_subtotal - subtotal) / 100).toFixed(
                  2
                ),
                percentage: promotion?.percentage,
              })}
            </div>
          )}
        </div>
      </div>
      <a
        className="btn btn-primary btn-block btn-lg"
        title="Checkout"
        disabled={disabled && "disabled"}
        href="#"
        onClick={(event) => {
          event.preventDefault()
          onClick()
        }}
      >
        {text}
      </a>
    </div>
  )
}

export default CheckoutButton
